import { supabase } from './supabase';

export interface AccessibleHome {
  id: string;
  address: string;
  city: string;
  state: string;
  /** When set, walkthrough availability is filtered to this market; null uses the app default market */
  market_id?: string | null;
  plan?: string | null;
  plan_source?: string | null;
  plan_updated_at?: string | null;
  zip_code?: string;
  created_at?: string;
  owner_id?: string | null;
  home_manager?: string | null;
  home_manager_assigned_at?: string | null;
  cover_photo_url?: string | null;
  square_footage?: number | null;
  year_built?: number | null;
  purchase_date?: string | null;
  bedrooms?: number | null;
  bathrooms?: number | null;
}

export const getAccessibleHomeIds = async (userId: string): Promise<string[]> => {
  const { data: memberships, error: membershipError } = await supabase
    .from('home_members')
    .select('home_id')
    .eq('user_id', userId)
    .is('removed_at', null);

  if (membershipError) throw membershipError;
  return (memberships || []).map((membership) => membership.home_id);
};

export const getAccessibleHomes = async (userId: string): Promise<AccessibleHome[]> => {
  const homeIds = await getAccessibleHomeIds(userId);
  if (homeIds.length === 0) return [];

  const { data: homes, error: homesError } = await supabase
    .from('homes')
    .select('id, owner_id, address, city, state, zip_code, market_id, plan, plan_source, plan_updated_at, created_at, cover_photo_url, square_footage, year_built, purchase_date, bedrooms, bathrooms, home_manager, home_manager_assigned_at')
    .in('id', homeIds)
    .order('created_at', { ascending: false });

  if (homesError) throw homesError;
  return homes || [];
};
